import './HomeItemCss.css';
import {Col} from 'react-bootstrap';
import {UrlFixer} from "../../utils/utils";
import {useNavigate} from "react-router-dom";
import {StyledEventRow, StyledEventPost, StyledEventThumb, StyledEventText} from "../../utils/common-styles";


export const HomeEventItem = (props) => {

    const eventItem = props.eventItem;

    const navigate = useNavigate();

    function clickHandler(eventItemId, slug) {
        let url = "/events/" + eventItemId + "/" + slug;
        navigate(url);
    }

    return (
        <StyledEventRow onClick={(e) => clickHandler(eventItem.id, eventItem.slug)}>
        <StyledEventPost>
            <StyledEventThumb xs={12}>
                <img src={UrlFixer(eventItem.image)} alt="" />
                <div className="post-meta">
                <ul className="post-meta">
                    <li>{new Date(eventItem.starts_at).toLocaleString("default", {
              month: "short", year: "numeric", day: "numeric"
            })}</li>
                    <li>{new Date(eventItem.starts_at).toLocaleString("default", {
              hour: "2-digit", minute: "2-digit", hour12: true
            })}</li>
                </ul>
                </div>
            </StyledEventThumb>
            <Col xs={12}>
            <StyledEventText>
                <h6><a href={`/events/${eventItem.id}/${eventItem.slug}`}>{eventItem.title}</a></h6>
                <p>{eventItem.intro}</p>
            </StyledEventText>
            </Col>
        </StyledEventPost>
        </StyledEventRow>
    )
}
